import { CYBER_CONSTANT } from 'constants';

import React from 'react';

import StateBadge from 'components/atoms/statebadge';

import './CyberLegends.scss';

function CyberLegends() {
  return (
    <div className="cyberLegends__wrapper">
      <div className="cyberLegends__legends">
        {CYBER_CONSTANT.LEGENDS.map((item) => (
          <div key={item.state} className="cyberLegends__legendItem">
            <div className={`cyberLegends__legendSuqare${item.state.toLowerCase()}`} />
            <StateBadge state={item.state} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default CyberLegends;
